import { useDataProvider, useRefresh, useNotify, useRecordContext } from "react-admin";
import { Button } from "@mui/material";
import { studentRequests } from "api/studentApi";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import MailIcon from "@mui/icons-material/Mail";
import { useState } from "react";

const NotifyDepartmentsButton = () => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const notify = useNotify();
  const [notificationSended, setNotificationSended] = useState(false);

  const handleNotify = async () => {
    const body = { weeklyScheduleId: record?.id };
    await dataProvider.customRequest(studentRequests.notifyWeeklyScheduleCreation(), body, "PUT");
    refresh();
    setNotificationSended(true);
    notify("Успешно изпратени нотификации към катедрите", { type: "success" });
  };

  return !notificationSended ? (
    <ConfirmModal
      onConfirm={handleNotify}
      titleContent={"Изпращане на нотификация до катедри"}
      message="Сигурни ли сте, че искате да изпратите нотификация до катедрите провеждащи обучението?"
      triggerButton={
        <Button startIcon={<MailIcon />}>Нотифицирай катедри</Button>
      }
    />
  ) : null;
};

export default NotifyDepartmentsButton;
